import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Sprout, ShieldCheck, Check } from 'lucide-react';
const modules = [{
  num: '01',
  title: 'Reset',
  subtitle: 'Limpieza',
  days: 'Días 1-7',
  focus: 'Desinflamación sistémica desde la raíz.',
  description: 'Identificamos y retiramos los irritantes ocultos que provocan tu inflamación abdominal. Calmas el sistema digestivo y desbloqueas tu energía natural desde la primera semana.',
  highlights: ['Protocolo antiinflamatorio diario', 'Alimentos a eliminar y por qué', 'Pautas de hidratación funcional'],
  icon: Sparkles,
  bg: 'bg-salvia/15',
  border: 'border-salvia/40',
  accent: 'bg-forest text-white',
  iconColor: 'text-forest'
}, {
  num: '02',
  title: 'Microbiota',
  subtitle: 'Re-población',
  days: 'Días 8-14',
  focus: 'Restaurar una flora intestinal saludable y diversa.',
  description: 'Re-introducimos nutrientes y alimentos clave que alimentan tus bacterias buenas. Tu microbiota se diversifica y la digestión se vuelve fluida, sin gases ni pesadez.',
  highlights: ['Guía de prebióticos y probióticos', 'Reintroducción guiada paso a paso', 'Detector de alimentos trigger'],
  icon: Sprout,
  bg: 'bg-olive',
  border: 'border-salvia/30',
  accent: 'bg-forest text-white',
  iconColor: 'text-forest'
}, {
  num: '03',
  title: 'Estabilidad',
  subtitle: 'Mantenimiento',
  days: 'Días 15-21',
  focus: 'Resultados a largo plazo sin efecto rebote.',
  description: 'Consolidamos hábitos y fortalecemos la barrera intestinal. Te llevas un plan claro para mantener tu vientre plano y tu energía sin volver a los síntomas de antes.',
  highlights: ['Plan de mantenimiento 360°', 'Rutinas anti-recaída', 'Estrategia para imprevistos'],
  icon: ShieldCheck,
  bg: 'bg-cream-warm',
  border: 'border-salvia/40',
  accent: 'bg-forest text-white',
  iconColor: 'text-forest'
}];
export function Method() {
  return <section className="py-24 md:py-36 bg-cream" data-id="element-114">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-115">
        <div className="text-center mb-16 md:mb-20 max-w-2xl mx-auto" data-id="element-116">
          <span className="text-salvia font-semibold tracking-[0.25em] text-xs uppercase mb-4 block" data-id="element-117">
            El Protocolo, Paso a Paso
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-forest leading-[1.1]" data-id="element-118">
            3 módulos que rehacen tu digestión en{' '}
            <span className="text-forest/70 italic font-normal" data-id="element-119">21 días</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7" data-id="element-120">
          {modules.map((mod, index) => {
          const Icon = mod.icon;
          return <motion.article key={index} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.12
          }} className={`relative ${mod.bg} border ${mod.border} rounded-3xl p-7 md:p-8 flex flex-col`} data-id="element-121">
                <div className="flex items-center justify-between mb-6" data-id="element-122">
                  <div className="flex items-center gap-3" data-id="element-123">
                    <span className="w-11 h-11 rounded-full bg-white border border-salvia/30 flex items-center justify-center shadow-sm" data-id="element-124">
                      <Icon className={`w-5 h-5 ${mod.iconColor}`} strokeWidth={2} data-id="element-125" />
                    </span>
                    <span className="text-xs font-bold tracking-[0.22em] uppercase text-forest/60" data-id="element-126">
                      Módulo {mod.num}
                    </span>
                  </div>
                  <span className={`inline-flex items-center text-[11px] font-bold tracking-tight uppercase px-2.5 py-1 rounded-full ${mod.accent}`} data-id="element-127">
                    {mod.days}
                  </span>
                </div>

                <h3 className="font-serif text-2xl md:text-[1.7rem] font-semibold tracking-tight text-forest leading-[1.15] mb-1" data-id="element-128">
                  {mod.title}
                </h3>
                <p className="text-sm font-semibold text-forest/55 tracking-tight mb-3" data-id="element-129">
                  ({mod.subtitle})
                </p>

                <p className="text-[13px] font-semibold text-salvia tracking-tight uppercase mb-3 leading-snug" data-id="element-130">
                  {mod.focus}
                </p>

                <p className="text-[15px] text-forest/75 leading-relaxed mb-6" data-id="element-131">
                  {mod.description}
                </p>

                <ul className="space-y-2.5 mt-auto pt-5 border-t border-salvia/25" data-id="element-132">
                  {mod.highlights.map((h, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-forest/85 font-medium" data-id="element-133">
                      <Check className="w-4 h-4 text-forest mt-0.5 shrink-0" strokeWidth={2.5} data-id="element-134" />
                      <span data-id="element-135">{h}</span>
                    </li>)}
                </ul>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}